"use client";

import { useAnalytics } from "@/app/components/hooks/useAnalytics";
import { useGlobalContext } from "@/app/context";

export function AnalyticsProvider({ children }: { children: React.ReactNode }) {
  const { userData } = useGlobalContext();

  // Initialize analytics with automatic page view tracking
  useAnalytics({
    trackPageViews: true,
    userId: userData?.userId || null,
  });

  return <>{children}</>;
}
